import type { AliiConnectType } from './aliiConnectType';

const integrationLogoAliases: Partial<Record<AliiConnectType, string>> = {
  XeroECCR: 'xero',
};

export function getIntegrationLogoPath(integrationType: AliiConnectType): string {
  const logoName = integrationLogoAliases[integrationType] ?? integrationType.toLowerCase();

  return `/integration-logos/${logoName}.png`;
}
